import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const CorporativoBusinessBankingLoginWeb = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const currentParams = location.search;

  const handleLogin = () => {
    navigate(`/business_banking-landing-corporativo-web${currentParams}`);
  };

  const handleSignupTab = () => {
    navigate(`/business_banking-signup-corporativo-web${currentParams}`);
  };

  const laptop = {
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#333",
    borderRadius: "15px 15px 5px 5px",
    padding: "17px",
    width: "1400px",
    height: "800px",
    position: "relative",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
  };

  const screen = {
    backgroundColor: "white",
    borderRadius: "5px",
    overflow: "hidden",
    width: "100%",
    height: "100%",
  };

  const base = {
    position: "absolute",
    width: "1600px",
    height: "20px",
    backgroundColor: "rgb(170, 170, 170)",
    borderRadius: "0px 0px 10px 10px",
    bottom: 0,
  };

  // SVG icons inline
  const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  );

  const LockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  );

  const EyeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );

  const EyeOffIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"/>
      <path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"/>
      <path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"/>
      <path d="m2 2 20 20"/>
    </svg>
  );

  return (
    <div style={laptop}>
      <div style={screen}>
        <div className="bb-login-screen">
          {/* Left panel - decorative gradient */}
          <div className="bb-login-left">
            <div
              className="bb-login-left-gradient"
              style={{
                background: `linear-gradient(160deg, ${colors.primario} 0%, ${colors.quinto} 100%)`,
              }}
            />

            <div
              className="bb-login-left-sphere-1"
              style={{
                background: `radial-gradient(circle at 40% 40%, ${colors.terciario}, ${colors.primario}00)`,
              }}
            />

            <div
              className="bb-login-left-sphere-2"
              style={{
                background: `radial-gradient(circle at 60% 35%, ${colors.secundario}cc, ${colors.quinto}00)`,
              }}
            />

            <div
              className="bb-login-left-sphere-3"
              style={{
                background: `radial-gradient(circle at 50% 40%, ${colors.septimo}aa, ${colors.primario}00)`,
              }}
            />

            <div
              className="bb-login-left-ring-1"
              style={{ borderColor: colors.cuaternario }}
            />

            <div
              className="bb-login-left-ring-2"
              style={{ borderColor: colors.sexto }}
            />

            <div
              className="bb-login-left-overlay"
              style={{
                background: `radial-gradient(ellipse 70% 50% at 30% 70%, ${colors.secundario}33 0%, transparent 70%)`,
              }}
            />

            <div className="bb-login-left-tagline">
              <h1>A bank specialized in businesses</h1>
            </div>
          </div>

          {/* Right panel - login form */}
          <div className="bb-login-right">
            <div className="bb-login-right-topbar">
              <button className="bb-login-lang-btn">
                <img
                  src="https://webfly-j.presales01.veritran.cloud/api/resources/4720/bandera_us"
                  alt="EN"
                />
                EN
              </button>
            </div>

            <div className="bb-login-form-wrapper">
              <div className="bb-login-form-container">
                {/* Logo */}
                {colors.url_logo && (
                  <div className="bb-login-logo">
                    <img src={colors.url_logo} alt="Logo" />
                  </div>
                )}

                <h2 className="bb-login-welcome">Welcome!</h2>
                <p className="bb-login-subtitle">
                  Enter your credentials to access your account
                </p>

                <div className="bb-login-form">
                  {/* Reference Data field */}
                  <div className="bb-login-field">
                    <label className="bb-login-label">Reference Data</label>
                    <div className="bb-login-input-wrapper">
                      <span className="bb-login-input-icon">
                        <UserIcon />
                      </span>
                      <input
                        className="bb-login-input"
                        type="text"
                        placeholder="Email, Phone, or Document"
                      />
                    </div>
                  </div>

                  {/* Password field */}
                  <div className="bb-login-field">
                    <label className="bb-login-label">Password</label>
                    <div className="bb-login-input-wrapper">
                      <span className="bb-login-input-icon">
                        <LockIcon />
                      </span>
                      <input
                        className="bb-login-input"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter password"
                      />
                      <button
                        className="bb-login-trailing-icon"
                        onClick={() => setShowPassword(!showPassword)}
                        type="button"
                      >
                        {showPassword ? <EyeOffIcon /> : <EyeIcon />}
                      </button>
                    </div>
                  </div>

                  {/* Submit button */}
                  <button
                    className="bb-login-submit"
                    style={{ backgroundColor: colors.primario }}
                    onClick={handleLogin}
                    type="button"
                  >
                    Login
                  </button>

                  <div className="bb-login-help">
                    <a
                      href="#"
                      style={{ color: colors.terciario }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleSignupTab();
                      }}
                    >
                      Don't have an account? Sign up
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={base}></div>
    </div>
  );
};
